import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { FormlyFieldProps } from '../../..';

interface CustomFieldProps extends FormlyFieldProps {
  customTemplate?: Observable<TemplateRef<any> | undefined>;
}

@Component({
  selector: 'kon-custom-template-type',
  standalone: true,
  imports: [CommonModule],
  template: `
    <ng-container
      *ngTemplateOutlet="(props.customTemplate | async) || null"
    ></ng-container>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTemplateTypeComponent extends FieldType<
  FieldTypeConfig<CustomFieldProps>
> {}
